export default "/images/vendor/flag-icon-css/flags/4x3/mq.svg?e82d6df9e99c87fb655bdcdc315d2730";